import { createTRPCReact, type CreateTRPCReact } from '@trpc/react-query';
import { httpBatchLink, type TRPCClient } from '@trpc/client';
import type { AppRouter } from '@4each/api/router';

export const trpc: CreateTRPCReact<AppRouter, unknown> = createTRPCReact<AppRouter>();

export function createTrpcClient(): TRPCClient<AppRouter> {
  return trpc.createClient({
    links: [
      httpBatchLink({
        url: '/trpc',
        fetch(url, options) {
          return fetch(url, { ...options, credentials: 'include' });
        },
      }),
    ],
  });
}
